import axios from "axios";
import BASE_API_URL from "./Config";

const axiosInstance = axios.create({
  baseURL: BASE_API_URL,
  withCredentials: true, // cookies (access + refresh) are sent automatically
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Do NOT attach Authorization header manually
    // Token is expected to be handled by cookies (HttpOnly)

    if (
      config.data &&
      !(config.data instanceof FormData) &&
      !config.headers["Content-Type"]
    ) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await axios.post(
          `${BASE_API_URL}/token/refresh/`,
          {},
          { withCredentials: true }
        );
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        return Promise.reject({
          ...refreshError,
          redirectToLogin: true,
        });
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
